var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "filter-tag-" + _vm.filter.code,
      staticClass: "listing-table-filters__container"
    },
    [
      _c("ListingTableFiltersTag", {
        ref: "filter-tag-trigger",
        attrs: {
          type: _vm.filter.code,
          label: _vm.filter.activeLabel,
          valuesHumanized: _vm.valuesHumanized
        },
        on: {
          clickOnTag: function($event) {
            return _vm.updateVisibility(true)
          },
          removeFilter: _vm.removeFilter
        }
      }),
      _vm._v(" "),
      _vm.TYPES.POPOVER === _vm.type
        ? _c(
            "CompassPopover",
            _vm._b(
              {
                attrs: {
                  triggerRef: "filter-tag-trigger",
                  noCloseOnClickOutside:
                    ".listing-settings-header__filters-select-dropdown",
                  customClass:
                    "listing-filter-popover " + _vm.filterConfig.customClass
                },
                on: {
                  close: function($event) {
                    return _vm.updateVisibility(false)
                  }
                }
              },
              "CompassPopover",
              _vm.filterConfig,
              false
            ),
            [_vm._t("filterDropdownContent")],
            2
          )
        : _c(
            "CompassDropdown",
            _vm._b(
              {
                attrs: {
                  parentRef: "filter-tag-" + _vm.filter.code,
                  value: _vm.filterValues,
                  filterablePlaceholder: _vm.$t.__("common.labels.search"),
                  noResultsLabel: _vm.$t.__("common.labels.no_result"),
                  blackListedSelector:
                    ".listing-settings-header__filters-select-dropdown"
                },
                on: {
                  onApplied: _vm.onApplyFilter,
                  "update:value": _vm.onSelectFilterValue,
                  onVisibilityChanged: _vm.updateVisibility
                }
              },
              "CompassDropdown",
              _vm.filterConfig,
              false
            ),
            [_vm._t("filterDropdownContent")],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }